import { render, staticRenderFns } from "./KanapowaMenadzerka.vue?vue&type=template&id=53490242&scoped=true&"
import script from "./KanapowaMenadzerka.vue?vue&type=script&lang=js&"
export * from "./KanapowaMenadzerka.vue?vue&type=script&lang=js&"
import style0 from "./KanapowaMenadzerka.vue?vue&type=style&index=0&id=53490242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53490242",
  null
  
)

export default component.exports